module.exports = __webpack_public_path__ + "1c7fa050148982ef8c0a1452d79d02c9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/quanta_services_2023_chart.png
// module id = 1729
// module chunks = 0